import { motion } from "framer-motion";
import { MapPin, Users, Target } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="min-h-screen" data-testid="about-page">
      <section className="pt-28 md:pt-36 pb-12 md:pb-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="font-display font-bold text-4xl sm:text-5xl text-white leading-tight mb-6">
              About Geminii
            </h1>
            <p className="text-lg text-geminii-muted max-w-2xl leading-relaxed mb-12">
              Geminii builds software, hardware control, and AI tools for businesses that operate in the real world. We build for operators who need things to work — not look good in a pitch deck.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            {[
              { icon: Target, title: "Mission", desc: "Give every operator the tools to run their business from their phone. No compromises, no enterprise-only pricing." },
              { icon: Users, title: "Team", desc: "Small, focused team. Engineers who've built field service tools, SCADA systems, and CRM platforms. We use what we build." },
              { icon: MapPin, title: "Global", desc: "Multi-country, multi-currency, multi-language. Local support in every region we operate. Built for how businesses work everywhere." },
            ].map((item, i) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="bg-geminii-card border border-white/[0.06] rounded-xl p-8"
              >
                <item.icon size={28} className="text-rogue-cyan mb-4" />
                <h3 className="font-display font-bold text-base text-white mb-2">{item.title}</h3>
                <p className="text-sm text-geminii-muted leading-relaxed">{item.desc}</p>
              </motion.div>
            ))}
          </div>

          <div className="mt-16 text-sm text-geminii-dim">
            <p>For enquiries, contact <a href="mailto:hello@geminii-ai.com" className="text-rogue-cyan hover:underline">hello@geminii-ai.com</a></p>
          </div>
        </div>
      </section>
    </div>
  );
}
